<template>
    <app-content-admin>
        <template slot="header">{{$t("member_new")}}</template>

        <v-layout row wrap>

            <v-flex xs12 lg6 mx-auto>
                <v-card>
                    <v-card-text>
                        <v-card-title>
                            {{ $t('member_detail') }}
                        </v-card-title>
                        <v-container fluid grid-list-xs>
                            <v-layout wrap>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('name')"
                                        v-model="form.name"
                                        :rules="[rules.required('name')]"
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('email')"
                                        v-model="form.email"
                                        :rules="[rules.required('email')]"
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('mobile')"
                                        v-model="form.mobile_no"
                                        :rules="[rules.required('mobile_no')]"
                                        outlined
                                        prefix="+60"
                                    >
                                    </v-text-field>
                                </v-flex>

                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="submit()"
                            class="form-submit"
                        >
                            {{ $t('submit') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>

            </v-flex>

        </v-layout>

    </app-content-admin>

</template>

<script>
import vForm from '@/mixins/vForm'

export default {
    mixins: [vForm],

    data(){
        return {
            form: {
                name: null,
                email: null,
                mobile_no: null,
            },
        }
    },

    methods: {
        async submit() {
            let loader = this.$loading.show();

            await axios.post(api.path('member.create'), this.form)
            .then(res => res.data)
                .then(res =>  {
                    this.$toastr.s(this.$t(res.message));
                    loader.hide();
            }).catch(error => {
                console.log(error)
                    this.$toastr.e(error.response.data.message);
                    loader.hide();
            });

            loader.hide();
        },

    }
}

</script>
